import React, {Dispatch, FC, SetStateAction, useMemo} from 'react';
import {Tabs, TabsList, TabsTrigger} from "@src/@/components/ui/tabs";
import {classNames} from "@modules/casting/String";


type Props = {
    titles: string[] | undefined,
    tabState: [number, Dispatch<SetStateAction<number>>]
}

const PlanTab: FC<Props> = ({titles, tabState}) => {

    const [currentTabIndex, setCurrentTabIndex] = useMemo(() => tabState, [tabState[0]]);

    const currentTab = useMemo(() => {
        return titles?.[currentTabIndex]
    }, [titles, currentTabIndex]);

    const handleChange = (label: string) => {
        if (titles) {
            setCurrentTabIndex(titles.findIndex(l => l == label))
        }

    }

    return (
        <Tabs
            defaultValue={currentTab}
            value={currentTab}
            onValueChange={handleChange}
            className={'bg-neutral-200 rounded-md mx-auto'}
        >
            <TabsList className={'grid grid-cols-3 w-full gap-x-4 h-auto items-center'}>
                {titles?.map((label, index) => <TabsTrigger
                    key={index}
                    value={label}
                    className={classNames(
                        'text-lg font-roboto font-medium',
                        currentTab === label && 'bg-primary-800 text-neutral-100'
                    )}
                >
                    {label}
                </TabsTrigger>)}
            </TabsList>
        </Tabs>

    );
};

export default PlanTab;
